/**
 * The loading screen (#boot, written in each page's HTML with its own inline style, so that it covers the page before
 * any stylesheet or script arrives): taken away once the page is ready — `waits` resolved (the sprites…), the fonts
 * loaded and a first frame painted under it — with a short fade. The page's inline script removes it anyway after
 * 15 s, so that a failed script never leaves a black screen.
 */
export function bootDone(...waits: Promise<unknown>[]): void {
  const el = document.getElementById('boot');
  if (!el) return;
  void Promise.allSettled([...waits, document.fonts.ready]).then(() => {
    requestAnimationFrame(() => requestAnimationFrame(() => {
      el.classList.add('gone');
      setTimeout(() => el.remove(), 350);
    }));
  });
}
